import { SnackbarProvider as NotistackSnackbarProvider } from 'notistack';
import { snackBarConfig } from './snackbarConfig';

interface SnackbarProviderProps {
  children: React.ReactNode;
}

export function SnackbarProvider({ children }: SnackbarProviderProps) {
  return <NotistackSnackbarProvider {...snackBarConfig}>{children}</NotistackSnackbarProvider>;
}
